import { action, observable, makeObservable } from 'mobx';

export interface IQuarantinedFile {
    id: string;
    status: string;
}

export const QUARANTINED = 'Quarantined';

export default class QuarantinedFileStore {
    quarantinedFile: IQuarantinedFile = {
        id: '',
        status: ''
    };

    constructor(quarantinedFile: IQuarantinedFile) {
        makeObservable(this, {
            quarantinedFile: observable,
            update: action
        });

        this.update(quarantinedFile);
    }

    update(quarantinedFile: IQuarantinedFile): void {
        this.quarantinedFile = {
            ...this.quarantinedFile,
            ...quarantinedFile
        };
    }

    public flatten(): any {
        return this._flatten(this.quarantinedFile);
    }

    private _flatten(input?: any): any {
        return;
    }
}
